import React, { createContext, useContext } from "react";
import { useFeatureFlags } from "@/hooks/useFeatureFlag";

// Define the context type for better type safety
interface FeatureFlagContextType {
  flags: Record<string, boolean>;
  isEnabled: (flagName: string) => boolean;
  isLoading: boolean;
}

const FeatureFlagContext = createContext<FeatureFlagContextType>({
  flags: {},
  isEnabled: () => false,
  isLoading: false,
});

interface FeatureFlagProviderProps {
  children: React.ReactNode;
}

export const FeatureFlagProvider = ({ children }: FeatureFlagProviderProps) => {
  const { data: flags = {}, isLoading } = useFeatureFlags();
  
  const isEnabled = (flagName: string): boolean => {
    return flags[flagName] ?? false;
  };
  
  return (
    <FeatureFlagContext.Provider value={{ flags, isEnabled, isLoading }}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export const useFeature = (flagName: string): boolean => {
  const { isEnabled } = useContext(FeatureFlagContext);
  return isEnabled(flagName);
};
